import { useEffect, useState } from 'react'
import { ISelectOption } from 'components/forms/Selects'
import {
  useGetShipmentIssueFaults,
  useGetShipmentIssueReasons,
  useGetShipmentIssueTypes,
  useGetShipmentIssueCategories,
} from 'apps/marketplace/apiTypes/shipmentIssues'

const useIssuesApi = () => {
  const {
    data: issueTypesResp,
    loading: loadingIssueTypes,
    refetch: refetchIssueTypes,
  } = useGetShipmentIssueTypes({})
  const { data: faultsResp } = useGetShipmentIssueFaults({})
  const { data: reasonsResp } = useGetShipmentIssueReasons({})
  const { data: categoriesResp } = useGetShipmentIssueCategories({})

  const [listFaults, setListFaults] = useState<ISelectOption[]>([])
  const [listReasons, setListReasons] = useState<ISelectOption[]>([])
  const [listTypes, setListTypes] = useState<ISelectOption[]>([])
  const [listCategories, setListCategories] = useState<ISelectOption[]>([])

  useEffect(() => {
    if (issueTypesResp?.shipmentIssueTypes) {
      const options = issueTypesResp.shipmentIssueTypes.map(issue => ({
        label: issue.name,
        value: issue.id,
        description: issue.description || '',
      }))
      setListTypes(options)
    }
  }, [issueTypesResp])

  useEffect(() => {
    if (faultsResp?.shipmentIssueFaults) {
      const options = faultsResp.shipmentIssueFaults.map(fault => ({
        label: fault.fault,
        value: fault.id,
      }))
      setListFaults(options)
    }
  }, [faultsResp])

  useEffect(() => {
    if (reasonsResp?.shipmentIssueReasons) {
      const options = reasonsResp.shipmentIssueReasons.map(reason => ({
        label: reason.reason,
        value: reason.id,
      }))
      setListReasons(options)
    }
  }, [reasonsResp])

  useEffect(() => {
    if (categoriesResp?.shipmentIssueCategories) {
      const options = categoriesResp.shipmentIssueCategories.map(category => ({
        label: category.name,
        value: category.id,
      }))
      setListCategories(options)
    }
  }, [categoriesResp])

  return {
    options: {
      faults: listFaults,
      reasons: listReasons,
      types: listTypes,
      categories: listCategories,
    },
    data: {
      faults: faultsResp?.shipmentIssueFaults || [],
      reasons: reasonsResp?.shipmentIssueReasons || [],
      types: issueTypesResp?.shipmentIssueTypes || [],
      categories: categoriesResp?.shipmentIssueCategories || [],
    },
    refetchIssueTypes,
    loadingIssueTypes,
  }
}

export default useIssuesApi
